export const MFITT = {
  namespaced: true,
  state: {
    inputtedInfoOnBooking: null,
    vacancyInquiry: null,
    carNumberVacancyStatus: null,
    myLimitedExpressTicket: null,
    myLimitedExpressTickets: null,
    refundSeats: null,
    ticketPrice: null,
    myCoupons: null,
    selectedCoupon: null,
    paymentMethods: [],
    selectedPaymentMethod: null,
    bookingResult: null,
    showProcessingDialog: false,
    paymentResult: null,
    showDenyPurchaseWarning: null,
  },
  getters: {
    inputtedInfoOnBooking(state) {
      return state.inputtedInfoOnBooking;
    },
    vacancyInquiry(state) {
      return state.vacancyInquiry;
    },
    carNumberVacancyStatus(state) {
      return state.carNumberVacancyStatus;
    },
    myLimitedExpressTicket(state) {
      return state.myLimitedExpressTicket;
    },
    myLimitedExpressTickets(state) {
      return state.myLimitedExpressTickets;
    },
    refundSeats(state) {
      return state.refundSeats;
    },
    ticketPrice(state) {
      return state.ticketPrice;
    },
    myCoupons(state) {
      return state.myCoupons;
    },
    selectedCoupon(state) {
      return state.selectedCoupon;
    },
    paymentMethods(state) {
      return state.paymentMethods;
    },
    selectedPaymentMethod(state) {
      return state.selectedPaymentMethod;
    },
    bookingResult(state) {
      return state.bookingResult;
    },
    showProcessingDialog(state) {
      return state.showProcessingDialog;
    },
    paymentResult(state) {
      return state.paymentResult;
    },
    showDenyPurchaseWarning(state) {
      return state.showDenyPurchaseWarning;
    },
  },
  mutations: {
    setInputtedInfoOnBooking(state, inputtedInfoOnBooking) {
      state.inputtedInfoOnBooking = inputtedInfoOnBooking;
    },
    setVacancyInquiry(state, vacancyInquiry) {
      state.vacancyInquiry = vacancyInquiry;
    },
    setCarNumberVacancyStatus(state, carNumberVacancyStatus) {
      state.carNumberVacancyStatus = carNumberVacancyStatus;
    },
    setMyLimitedExpressTicket(state, myLimitedExpressTicket) {
      state.myLimitedExpressTicket = myLimitedExpressTicket;
    },
    setMyLimitedExpressTickets(state, myLimitedExpressTickets) {
      state.myLimitedExpressTickets = myLimitedExpressTickets;
    },
    setRefundSeats(state, refundSeats) {
      state.refundSeats = refundSeats;
    },
    setTicketPrice(state, ticketPrice) {
      state.ticketPrice = ticketPrice;
    },
    setMyCoupons(state, myCoupons) {
      state.myCoupons = myCoupons;
    },
    setSelectedCoupon(state, selectedCoupon) {
      state.selectedCoupon = selectedCoupon;
    },
    setPaymentMethods(state, paymentMethods) {
      state.paymentMethods = paymentMethods;
    },
    setSelectedPaymentMethod(state, selectedPaymentMethod) {
      state.selectedPaymentMethod = selectedPaymentMethod;
    },
    setBookingResult(state, bookingResult) {
      state.bookingResult = bookingResult;
    },
    setShowProcessingDialog(state, showProcessingDialog) {
      state.showProcessingDialog = showProcessingDialog;
    },
    setPaymentResult(state, paymentResult) {
      state.paymentResult = paymentResult;
    },
    setShowDenyPurchaseWarning(state, showDenyPurchaseWarning) {
      state.showDenyPurchaseWarning = showDenyPurchaseWarning;
    },
  },
};
